// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#A347E8","menuText":"#fff","menuActiveText":"#fff","subMenuBg":"#fff","theme":"#a347e8"};